module.exports = __webpack_public_path__ + "img/arrow-error.ecfa0f4.svg";